import React, { useEffect } from "react";
//import Scss
import "./assets/scss/themes.scss";
import "./App.css";
import { useLocation } from "react-router-dom";

import { clearAuthSession, redirectToLogin } from "./helpers/api_helper";

//imoprt Route
import Route from "./Routes";

const logoutIfTokenExpire = () => {
  const expirationTime = localStorage.getItem("expiryAt");
  if (expirationTime) {
    const currentTime = new Date().getTime();
    if (currentTime > parseInt(expirationTime, 10)) {
      clearAuthSession();
      redirectToLogin();
    }
  }
};

function App() {
  const location = useLocation();

  // Call the token expiration check function on every route change
  useEffect(() => {
    logoutIfTokenExpire();
  }, [location]);

  // Mobile browsers often freeze the tab in the background; JWT and connections go stale.
  // Re-check expiry when the user returns so we redirect instead of "dead" clicks with a bad token.
  useEffect(() => {
    const onResume = () => {
      if (document.visibilityState === "visible") {
        logoutIfTokenExpire();
      }
    };
    const onPageShow = (e) => {
      if (e.persisted) {
        logoutIfTokenExpire();
      }
    };
    document.addEventListener("visibilitychange", onResume);
    window.addEventListener("pageshow", onPageShow);
    return () => {
      document.removeEventListener("visibilitychange", onResume);
      window.removeEventListener("pageshow", onPageShow);
    };
  }, []);

  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
